import pkg from '../../package.json'
export const isDebug = () => pkg.production !== true

export const getVersion = () => {
  if (pkg.environment === 'local') return 'local: Desenvolvimento'
  if (['production', 'beta', 'alpha', 'stable'].includes(pkg.environment.replace(/-web$/, ''))) return pkg.version
  return `${pkg.environment}: ${pkg.version}.${pkg.commit}`
}
